import { accountStatsService } from "fleet/service/account-stats";
import { createApiSaga } from "redux-store/api-sagas";

import {
  ACCOUNT_STATS_LOAD_BY_ACCOUNT,
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE,
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS,
  ACCOUNT_STATS_LOAD_BY_DATE,
  ACCOUNT_STATS_LOAD_BY_DATE_FAILURE,
  ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS,
} from "./actions";

const accountStatsLoadByAccountSaga = createApiSaga({
  service: accountStatsService.loadByAccount,
  serviceName: "accountStatsService.loadByAccount",
  fetchAction: ACCOUNT_STATS_LOAD_BY_ACCOUNT,
  successAction: ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS,
  failureAction: ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE,
  reload: false,
});

const accountStatsLoadByDateSaga = createApiSaga({
  service: accountStatsService.loadByDate,
  serviceName: "accountStatsService.loadByDate",
  fetchAction: ACCOUNT_STATS_LOAD_BY_DATE,
  successAction: ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS,
  failureAction: ACCOUNT_STATS_LOAD_BY_DATE_FAILURE,
  reload: false,
});

export { accountStatsLoadByAccountSaga, accountStatsLoadByDateSaga };
